import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import {
  JobWorkService,
    WorkOrderService
} from "../../../services/index";

@Component({
  selector: "addEditPurchaseOrder",
  templateUrl: "./addEditjobEstiWorkOrder.html",
})
export class AddEditjobEstiWorkOrder {
  row: any;
  data: any;
  designdata: any = {};
  wodata: any = {
    shirt_design_no: "",
    party_code: "",
    party_name: "",
    totalrate: 0,
    fullrate: 0,
    halfrate: 0,
    // f34_ratio: 0,
    f36_ratio: 0,
    f38_ratio: 0,
    f40_ratio: 0,
    f42_ratio: 0,
    f44_ratio: 0,
    f46_ratio: 0,
    // h34_ratio: 0,
    h36_ratio: 0,
    h38_ratio: 0,
    h40_ratio: 0,
    h42_ratio: 0,
    h44_ratio: 0,
    h46_ratio: 0,
    tot_full_ratio: 0,
    tot_half_ratio: 0,
  };
  qualityList: any;
  typeList: any;
  colorList: any;
  codeList: any;
  stockdata: any[];
  widthList: any[];
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  shadeList: any;
  designnoList: any[];

  designList = [
    {
      design_no: "",
      shade: "",
      meter: 0,
      mtr: 0,
      fs_tot_cons: 0,
      hs_tot_cons: 0,
      fs_tot_pcs: 0,
      hs_tot_pcs: 0,
      ftot: 0,
      htot: 0,
      fbalmtrs: 0,
      hbalmtrs: 0,
      totmtrs: 0,
      color : "",
      fab_design : ""
    },
  ];
  mode: string;
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
   
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);
   
    this.wodata = designdata;
    if (this.mode == "Edit" || this.mode == "Cancel") {
    
      //this.wodata.wo_date = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      // this.getpartyname(this.wodata.party_code);
      this.getDesignList(designdata.wo_id);
  
    } 
    else if (this.mode == "View") {
      this.wodata = designdata;
     
      this.wodata.wo_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    
      this.getDesignList(designdata.wo_id);
 
      //   this.getpartyname(this.wodata.party_code);
      //  this.getDesignList(this.wodata.wo_id);
    }
    else if (this.mode == "WorkOrder") {
       this.mode = "Add"
       this.wodata.fab_design = designdata.fab_no;
       this.wodata.jgrn_id = designdata.jgrn_id
       this.wodata.party_name = designdata.party_name
       this.getWoDesign(designdata.jgrn_id)
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private woservice: JobWorkService,
    private workservice: WorkOrderService
  ) {}
  ngOnInit() {
 
    this.tableScroll();
    if (this.mode == "Add" || this.mode == "view") {
      this.wodata.wo_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      // this.wodata.party_code = 'UNIT 1';
      if (this.mode == "Add") {
        this.getWoAuto(); 
     
      }
    }
  }

  tableScroll() {
    $(".workorderbody").height(window.innerHeight - 400);
    $(".workorderbody").width(window.innerWidth - 30);
  }

  ngAfterViewInit() {
    if (this.mode == "Add") {
      setTimeout(() => {
        $("#shirtno").focus();
      }, 100);
    } else {
      setTimeout(() => {
        $("#f36-1").focus();
      }, 100);
    }
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else if (nextEl == "f36-1") {
      $("#" + nextEl).select();
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      shade = this.designList[ind]["shade"],
      meter = this.designList[ind]["meter"],
      fper = this.designList[ind]["fper"],
      hper = this.designList[ind]["hper"],
      /*  f36 = this.designList[ind].f36,
            f38 = this.designList[ind].f38,
            f40 = this.designList[ind].f40,
            f42 = this.designList[ind].f42,
            f44 = this.designList[ind].f44,
            h36 = this.designList[ind].h36,
            h38 = this.designList[ind].h38,
            h40 = this.designList[ind].h40,
            h42 = this.designList[ind].h42,
            h44 = this.designList[ind].h44, */
      balmtrs = this.designList[ind].fbalmtrs,
      totmtrs = this.designList[ind]["totmtrs"];

    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "f36") {
      this.onSelectShade(this.designList[ind]["shade"], ind);
      $("#" + "f36" + "-" + nxtInd).focus();
      return false;
    }
    if (fld == "shade" && nxtRow.length == 0) {
      let len = this.designList.length;
      let shade = this.designList[len - 1]["shade"];

      nxtInd = nxtInd + 1;
      $("#" + "shade" + "-" + nxtInd).focus();

      if (shade != "" && nxtInd == len) {
        this.designList.push({
          design_no: "",
          shade: "",
          meter: 0,
          fs_tot_cons: 0,
          hs_tot_cons: 0,
          fs_tot_pcs: 0,
          hs_tot_pcs: 0,

          ftot: 0,
          mtr: 0,
          htot: 0,
          fbalmtrs: 0,
          hbalmtrs: 0,
          totmtrs: 0,
          color : "",
      fab_design : ""

        });

        $("#" + "shade" + "-" + nxtInd).focus();
      } else if (shade == "" && nxtInd == len) {
        let a = nxtInd - 1;
        $("#" + "shade" + "-" + a).focus();
      } else {
        $("#" + "shade" + "-" + nxtInd).focus();

        return false;
      }
    } else {
    /*  else if (fld=="f38" || fld=="f40" || fld=="f42" || fld=="f44" ||
            fld=="h36" || fld=="h38" || fld=="h40" || fld=="h42" || fld=="h44") {
            $('#'  + fld + '-' + nxtInd).select();
           
        }else if(fld=="f36"){
            nxtInd = nxtInd +1;
             $('#'  + fld + '-' + nxtInd).select();
        }
        else if (fld == "item_name") {
            let nxtRowID = nxtRow[0].id;
            nxtInd = nxtRowID.split("-")[1];
        } */
      setTimeout(() => {
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }
  getWoDesign(id) {
    let params = {jgrn_id : id};
    let that = this;
    this.woservice.getWoDesign(params).then(function (res: any) {
      that.designList = res.data;
    });
  }
  getDesignList(wo_id) {
    let params = {
      wo_id: wo_id,
    };
    this.woservice.getEditDesignList(params).then((res: any) => {
      for (let i = 0; i < res.data.length; i++) {
        this.designList[i] = res.data[i];
       
      }
    });
    this.calcTotal();
  }
  getShirtDesign() {
    let params = {};
    let that = this;
    this.workservice.getShirtDesign(params).then(function (res: any) {
      that.designnoList = res;
    });
  }

  isRowEmpty(ind) {
    let data = this.data.designList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }


  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.designList.length > 1) {
          that.designList.splice(ind, 1);

          if ($("#" + fld + "-" + (ind - 1)).length > 0) {
            $("#" + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + fld + "-" + (ind + 1)).length > 0) {
            $("#" + fld + "-" + (ind + 1)).focus();
          }
        }
        that.calcTotal();
      },
      function (dismiss) {}
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  returnWo() {
    //  this.designList.forEach(arr => {
    // if(arr.mtr==0 || arr.mtr==undefined ){
    //     swal("Make Sure that meter values are valid");
    //     return false
    // }

    //  else{

    this.woservice.returnWo({}).then((res: any) => {
      this.wodata.ref_no = res;
      this.getWoAuto();
    });
    this.oncheckemptyrow();

    //  }
    //  })
  }
  calcLimit(data, shade) {
    let totMtrs = 0;
    let totStock = 0;
    data.forEach((element) => {
      totMtrs += parseFloat(element.avl_mtrs);
    });
    this.designList.forEach((elm) => {
      if (elm.shade == shade) {
        totStock += Number(elm.mtr);
      }
    });
    if (totMtrs < Number(totStock)) {
      swal(" Meters value greater than Stock for shade " + shade);
      this.designList.forEach((val) => {
        if (val.shade == shade) {
          val.mtr = 0;
        }
      });
    }
  }

  getWoAuto() {
    this.woservice.getWoAuto({}).then((res: any) => {
      this.wodata.wo_no = "JW-" + res;
      this.wodata.ref_no = res;
   
    });
  }
  clearWorkorder() {
    this.designList = [
      {
        design_no: "",
        shade: "",
        meter: 0,
        fs_tot_cons: 0,
        hs_tot_cons: 0,
        fs_tot_pcs: 0,
        hs_tot_pcs: 0,
        ftot: 0,
        htot: 0,
        fbalmtrs: 0,
        hbalmtrs: 0,
        totmtrs: 0,
        mtr: 0,
        color : "",
      fab_design : ""

      },
    ];
  }

  onSelectShade(shade, ind) {
    this.stockdata = [];
    let params = {
      fab_design_no: this.wodata.fab_design,
      shirt_design_no: this.wodata.shirt_design_no,
      color: shade,
    };
    let that = this;
    that.woservice.getStock(params).then((res: any) => {
      if (res.data.length > 0) {
        this.stockdata = res.data;
      } else {
        this.designList[ind]["mtr"] = 0;
        this.designList[ind]["fs_tot_cons"] = 0;
        this.designList[ind]["hs_tot_cons"] = 0;
        this.designList[ind]["fs_tot_pcs"] = 0;
        this.designList[ind]["hs_tot_pcs"] = 0;
        // this.designList[ind]["f34"] = 0;
        this.designList[ind]["f36"] = 0;
        this.designList[ind]["f38"] = 0;
        this.designList[ind]["f40"] = 0;
        this.designList[ind]["f42"] = 0;
        this.designList[ind]["f44"] = 0;
        this.designList[ind]["f46"] = 0;
        // this.designList[ind]["h34"] = 0;
        this.designList[ind]["h36"] = 0;
        this.designList[ind]["h38"] = 0;
        this.designList[ind]["h40"] = 0;
        this.designList[ind]["h42"] = 0;
        this.designList[ind]["h44"] = 0;
        this.designList[ind]["h46"] = 0;
        this.calcBalMtrs(ind);
      }
      // this.designList[ind]['mtr']=this.stockdata[0]['avl_mtrs'];
      // this.woCalc(ind);
    });
  }
  woCalc(ind) {
    this.designList[ind]["fs_tot_cons"] =
      (this.designList[ind]["mtr"] * this.wodata.fsratio) / 100;
    this.designList[ind]["hs_tot_cons"] =
      (this.designList[ind]["mtr"] * this.wodata.hsratio) / 100;
    this.designList[ind]["fs_tot_pcs"] = Math.round(
      this.designList[ind]["fs_tot_cons"] / this.wodata.wo_full_cons
    );
    this.designList[ind]["hs_tot_pcs"] = Math.round(
      this.designList[ind]["hs_tot_cons"] / this.wodata.wo_half_cons
    );
    // this.designList[ind]["f34"] = Math.round(
    //   (this.designList[ind]["fs_tot_pcs"] * this.wodata.f34_calc) / 100
    // );
    this.designList[ind]["f36"] = Math.round(
      (this.designList[ind]["fs_tot_pcs"] * this.wodata.f36_calc) / 100
    );
    this.designList[ind]["f38"] = Math.round(
      (this.designList[ind]["fs_tot_pcs"] * this.wodata.f38_calc) / 100
    );
    this.designList[ind]["f40"] = Math.round(
      (this.designList[ind]["fs_tot_pcs"] * this.wodata.f40_calc) / 100
    );
    this.designList[ind]["f42"] = Math.round(
      (this.designList[ind]["fs_tot_pcs"] * this.wodata.f42_calc) / 100
    );
    this.designList[ind]["f44"] = Math.round(
      (this.designList[ind]["fs_tot_pcs"] * this.wodata.f44_calc) / 100
    );
    this.designList[ind]["f46"] = Math.round(
      (this.designList[ind]["fs_tot_pcs"] * this.wodata.f46_calc) / 100
    );
    // this.designList[ind]["h34"] = Math.round(
    //   (this.designList[ind]["hs_tot_pcs"] * this.wodata.h34_calc) / 100
    // );
    this.designList[ind]["h36"] = Math.round(
      (this.designList[ind]["hs_tot_pcs"] * this.wodata.h36_calc) / 100
    );
    this.designList[ind]["h38"] = Math.round(
      (this.designList[ind]["hs_tot_pcs"] * this.wodata.h38_calc) / 100
    );
    this.designList[ind]["h40"] = Math.round(
      (this.designList[ind]["hs_tot_pcs"] * this.wodata.h40_calc) / 100
    );
    this.designList[ind]["h42"] = Math.round(
      (this.designList[ind]["hs_tot_pcs"] * this.wodata.h42_calc) / 100
    );
    this.designList[ind]["h44"] = Math.round(
      (this.designList[ind]["hs_tot_pcs"] * this.wodata.h44_calc) / 100
    );
    this.designList[ind]["h46"] = Math.round(
      (this.designList[ind]["hs_tot_pcs"] * this.wodata.h46_calc) / 100
    );

    this.calcBalMtrs(ind);
  }
  calcBalMtrs(ind) {
    console.log(this.designList[ind]);
    let nan = function (no) {
      if (no == "" || no == null) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    };
    //ftotalpcs
    this.designList[ind]["ftot"] =
    // nan(this.designList[ind]["f34"]) +
      nan(this.designList[ind]["f36"]) +
      nan(this.designList[ind]["f38"]) +
      nan(this.designList[ind]["f40"]) +
      nan(this.designList[ind]["f42"]) +
      nan(this.designList[ind]["f44"]) +
      nan(this.designList[ind]["f46"]);

    //htotalpcs
    this.designList[ind]["htot"] =
    // nan(this.designList[ind]["h34"]) +
      nan(this.designList[ind]["h36"]) +
      nan(this.designList[ind]["h38"]) +
      nan(this.designList[ind]["h40"]) +
      nan(this.designList[ind]["h42"]) +
      nan(this.designList[ind]["h44"]) +
      nan(this.designList[ind]["h46"]);

    //balance meters
    this.designList[ind]["fbalmtrs"] =
      nan(this.designList[ind]["mtr"]) -
      nan(this.designList[ind]["ftot"] * this.wodata.wo_full_cons);
    this.designList[ind]["hbalmtrs"] =
      nan(this.designList[ind]["mtr"]) -
      nan(this.designList[ind]["htot"] * this.wodata.wo_half_cons);
    this.designList[ind]["balmtrs"] = nan(
      this.designList[ind]["fbalmtrs"] +
        this.designList[ind]["hbalmtrs"] -
        this.designList[ind]["mtr"]
    ).toFixed(2);

    this.calcTotal();
  }

  calcTotal() {
    let nan = function (no) {
        if (no == "" || no == null) {
          return 0;
        }
        if (isNaN(no)) {
          return 0;
        }
        return parseFloat(no + "");
      },
      fs_tot = 0,
      hs_tot = 0,
      // fh34_tot = 0,
      fh36_tot = 0,
      fh38_tot = 0,
      fh40_tot = 0,
      fh42_tot = 0,
      fh44_tot = 0,
      fh46_tot = 0,
      tot_pcs = 0;
    for (let i = 0; i < this.designList.length; i++) {
      const li = this.designList[i];
      fs_tot +=
      // nan(li["f34"]) +
        nan(li["f36"]) +
        nan(li["f38"]) +
        nan(li["f40"]) +
        nan(li["f42"]) +
        nan(li["f44"]) +
        nan(li["f46"]);
      hs_tot +=
      // nan(li["h34"]) +
        nan(li["h36"]) +
        nan(li["h38"]) +
        nan(li["h40"]) +
        nan(li["h42"]) +
        nan(li["h44"]) +
        nan(li["h46"]);
      // fh34_tot += nan(li["f34"]) + nan(li["h34"]);
      fh36_tot += nan(li["f36"]) + nan(li["h36"]);
      fh38_tot += nan(li["f38"]) + nan(li["h38"]);
      fh40_tot += nan(li["f40"]) + nan(li["h40"]);
      fh42_tot += nan(li["f42"]) + nan(li["h42"]);
      fh44_tot += nan(li["f44"]) + nan(li["h44"]);
      fh46_tot += nan(li["f46"]) + nan(li["h46"]);
      tot_pcs += nan(li["ftot"]) + nan(li["htot"]);
    }
    this.wodata.fs_total = fs_tot;
    this.wodata.hs_total = hs_tot;
    // this.wodata.fh34_tot = fh34_tot;
    this.wodata.fh36_tot = fh36_tot;
    this.wodata.fh38_tot = fh38_tot;
    this.wodata.fh40_tot = fh40_tot;
    this.wodata.fh42_tot = fh42_tot;
    this.wodata.fh44_tot = fh44_tot;
    this.wodata.fh46_tot = fh46_tot;
    this.wodata.tot_pcs = tot_pcs;
  }

  oncheckemptyrow() {
 
    if (
      !this.wodata.ref_no ||
      !this.wodata.wo_no
    ) {
      swal("Make sure that all the details are given!");
    } else {
    /*   else if(this.wodata.shirt_design_no){
            let design = this.designList;
            for(let i=0;i<design.length;i++){
                if(design[i]['balmtrs']>this.wodata.wo_half_cons){
                    this.toasterService.pop({
                        bodyOutputType: 1,
                        type: 'error',
                        title: 'Balance the meter!'
                    });  
                }
         }
        } */
      let design = this.designList;
      let desList = [];
      for (let i = 0; i < design.length; i++) {
        if (design[i].shade != "") {
          desList.push(design[i]);
        }

        this.designList = desList;
        // debugger;
        if (this.mode == "Cancel") {
          this.onsaveOrderReturn();
        } else {
          this.onSaveOrder();
        }
      }
    }
  }
  close() {
    let tabObj = {
      action: "CloseTab",
      params: {},
    };
    this.tabUpdateEvent.emit(tabObj);
  }

  onSaveOrder(): void {
    let params: any = Object.assign({}, this.wodata);
    params["tabevent"] = undefined;
    params["data"] = JSON.stringify(this.designList);
    params["mode"] = this.mode;
    params["wo_date"] = this.datePipe.transform(
      params["wo_date"],
      "yyyy-MM-dd"
    );
    let that = this;
    that.isLoading = true;
    swal({
      title: "Are you sure to save this Work Order?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      // $("#save").prop("disabled",true);
      that.isLoading = true;
      that.woservice
        .saveEstiOrder(params)
        .then(function (res: any) {
          that.isLoading = false;
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            let tabObj = {
              action: "CloseTab",
              params: {},
            };
            that.tabUpdateEvent.emit(tabObj);

            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }
  onsaveOrderReturn(): void {
    // debugger;
    let params: any = Object.assign({}, this.wodata);
    params["tabevent"] = undefined;
    params["data"] = JSON.stringify(this.designList);

    params["wo_date"] = this.datePipe.transform(
      params["wo_date"],
      "yyyy-MM-dd"
    );
    let that = this;
    that.isLoading = true;
    swal({
      title: "Are you sure to return this Work Order?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, return it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoading = true;
      that.woservice
        .saveOrderReturn(params)
        .then(function (res: any) {
          that.isLoading = false;
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            if (that.mode == "Cancel") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/jobworkorder/addEditjobEstiWorkOrder.ts